export type ParsedAiSummary = { lead: string; bullets: string[] };

/** Gates visibility of every AI summary display; kept in one place to avoid
 *  the permission name string drifting between the components that check it. */
export const RULE_ENGINE_AI_SUMMARY_PERMISSION = "can_use_rule_engine_ai_summary";

const BULLET_PATTERN = /^[-•*]\s+/;

/**
 * The AI summary prompts ask for a lead sentence followed by "- " prefixed
 * lines, one per rule/behaviour, for anything summarised at the fuller
 * (version or root rule set) level. Splitting that into a lead paragraph plus
 * a real bullet list reads far better than the raw dashes verbatim. Text with
 * no bullet lines (e.g. a terse nested rule-set summary) just becomes the lead.
 */
export const parseAiSummary = (text: string): ParsedAiSummary => {
	const lead: string[] = [];
	const bullets: string[] = [];

	text
		.split("\n")
		.map((line) => line.trim())
		.filter(Boolean)
		.forEach((line) => {
			if (BULLET_PATTERN.test(line)) {
				bullets.push(line.replace(BULLET_PATTERN, ""));
			} else if (bullets.length === 0) {
				lead.push(line);
			} else {
				// A wrapped continuation of the previous bullet, not a new one.
				bullets[bullets.length - 1] += ` ${line}`;
			}
		});

	return { lead: lead.join(" "), bullets };
};
